module.exports = __webpack_public_path__ + "img/portrait-077.026af322.jpg";